import { createAction } from '@reduxjs/toolkit'

import type { ListTable } from 'redux/reducers/Lists'

// tryGetListTables
export const getTables = createAction('get_list_tables')
export const getTablesSuccess = createAction<{ data: ListTable[] }>(
  'get_list_tables_success'
)
export const getTablesFailed = createAction('get_list_tables_failed')

// tryGetListData
export const getData = createAction<{ tableId: string }>('get_list_data')
export const getDataSuccess = createAction<{
  data: { count: number; rows: object[]; offset: number; tableId: string }
}>('get_list_data_success')
export const getDataFailed = createAction('get_list_data_failed')

// tryExportListTable
export const exportTable = createAction('export_list_table')
export const exportTableSuccess = createAction('export_list_table_success')
export const exportTableFailed = createAction('export_list_table_failed')
